import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { signalerCampagne } from "./lib/campagne";
import "./styles/tokens.css";
import "./styles/app.css";

/*
  L'arrivée de campagne se capte avant le premier rendu — 07/10/2026.

  Elle vivait dans un effet d'`App`. Or React exécute les effets des enfants
  avant ceux du parent : sur /dirigeant, `dirigeant_demarre` partait avant que
  la campagne soit retenue, et l'entrée de chaque visiteur venu d'une annonce
  dirigeant était comptée sans son annonce. La colonne « Dirigeants » de
  /pilotage restait à zéro pour les trois annonces qui y envoient.
*/
signalerCampagne();

const container = document.getElementById("root");
if (!container) throw new Error("élément #root introuvable");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
